import { SellCode } from "../parcels/parcel"
import { DocType } from "../shared"

export enum DeathState {
  ALIVE = 'alive',
  DEATH = 'death',
  CREMATED = 'cremated',
  BURIED = 'buried',
  REDUCED = 'reduced',
  EXHUMED = 'exhumed'
}

export enum TransferredTo {
  CEMENTERIO_MUNICIPAL_PARANA = 'Cementerio Municipal (Paraná)',
  PARQUE_DE_LA_PAZ_PARANA = 'Parque de La Paz (Paraná)',
  CEMENTERIO_MUNICIPAL_SANTA_FE = 'Cementerio Municipal (Santa Fe)',
  CEMENTERIO_PARQUE_SANTA_FE = 'Cementerio Parque (Santa Fe)',
  CEMENTERIO_PARQUE_LAR_DE_PAZ_SANTA_FE = 'Cementerio Parque Lar de Paz (Santa Fe)',
  OTRO = 'Otro'
}

export enum DeathRelationship {
  CONYUGE = 'conyuge',
  HIJO = 'hijo',
  PADRE = 'padre',
  MADRE = 'madre',
  HERMANO = 'hermano',
  ABUELO = 'abuelo',
  NIETO = 'nieto',
  TIO = 'tio',
  SOBRINO = 'sobrino',
  REPRESENTADO = 'representado',
  AMIGO = 'amigo',
  OTRO = 'otro'
}

export interface DeathData {
  id?: string
  contractId?: string
  name: string
  docType?: DocType
  docNumber?: string
  birthDate?: Date
  deathDate?: Date
  state?: DeathState
  cremationDate?: Date
  intermentDate?: Date
  disintermentDate?: Date
  reductionDate?: Date
  notes?: string
  thumbLevel?: number
  entryNumber?: string
  volume?: string
  year?: string
  leaf?: string
  office?: string
  mortuary?: string
  medicOfDeceased?: string
  deathCertificateAuthorization?: string
  relationshipWithDeceased?: DeathRelationship
  transferredTo?: string
  createdAt?: Date
  updatedAt?: Date
  createdBy?: string
  updatedBy?: string
}

export const formatDeathState = (state: DeathState): string => {
  const stateMap = {
    [DeathState.ALIVE]: 'Vivo',
    [DeathState.DEATH]: 'Fallecido',
    [DeathState.CREMATED]: 'Cremado',
    [DeathState.BURIED]: 'Sepultado',
    [DeathState.REDUCED]: 'Reducido',
    [DeathState.EXHUMED]: 'Exhumado'
  }
  return stateMap[state] || state
}

export const getDeathStateColor = (state: DeathState): string => {
  const colorMap = {
    [DeathState.ALIVE]: 'bg-green-100 text-green-800 hover:bg-green-100',
    [DeathState.DEATH]: 'bg-red-100 text-red-800 hover:bg-red-100',
    [DeathState.CREMATED]: 'bg-orange-100 text-orange-800 hover:bg-orange-100',
    [DeathState.BURIED]: 'bg-blue-100 text-blue-800 hover:bg-blue-100',
    [DeathState.REDUCED]: 'bg-purple-100 text-purple-800 hover:bg-purple-100',
    [DeathState.EXHUMED]: 'bg-gray-100 text-gray-800 hover:bg-gray-100'
  }
  return colorMap[state] || 'bg-gray-100 text-gray-800'
}

export const formatDeathRelationship = (relationship: DeathRelationship): string => {
  const relMap = {
    [DeathRelationship.CONYUGE]: 'Cónyuge',
    [DeathRelationship.HIJO]: 'Hijo/a',
    [DeathRelationship.PADRE]: 'Padre',
    [DeathRelationship.MADRE]: 'Madre',
    [DeathRelationship.HERMANO]: 'Hermano/a',
    [DeathRelationship.ABUELO]: 'Abuelo/a',
    [DeathRelationship.NIETO]: 'Nieto/a',
    [DeathRelationship.TIO]: 'Tío/a',
    [DeathRelationship.SOBRINO]: 'Sobrino/a',
    [DeathRelationship.REPRESENTADO]: 'Apoderado/a',
    [DeathRelationship.AMIGO]: 'Amigo/a',
    [DeathRelationship.OTRO]: 'Otro'
  }
  return relMap[relationship] || relationship
}
